import { State } from '@meraki-internal/state';
import { IWithNotesLink, NotesModel } from './NotesModel';
import { INote, INoteResponse } from './NotesClient';

export class NewNoteViewModel<T extends IWithNotesLink, R extends INoteResponse> extends State<Record<string, never>> {
    constructor(private note: INote, private notesVM: NotesModel<T, R>){
        super({ });
    }

    isValid = () => this.notesVM.getValidator().isValid(this.getNote());

    getNote = () => {
        return this.note;
    };

    setNote = (note: INote) => {
        this.note = note;
        this.setState({ });
    };

    private isSaving = false;

    private didSave = false;

    canSave = () => {
        // cannot save again
        if (this.didSave){
            return false;
        }

        return !this.isSaving && this.isValid();
    };

    save = async () => {
        this.isSaving = true;
        this.setState({ });

        try {
            const response =  await this.notesVM.addNewNote(this.getNote());

            this.didSave = true;
            this.setState({ });

            return response;

        }
        finally {
            this.isSaving = false;
            this.setState({ });
        }
    };
}
